const settings = {
  title: 'الإعدادات',
  subtitle: 'إدارة تفضيلات حسابك وإعدادات التطبيق',
  saveSettings: 'حفظ الإعدادات',
  saveSuccess: 'تم حفظ إعداداتك بنجاح',

  sections: {
    appearance: 'المظهر',
    notifications: 'الإشعارات',
    privacy: 'الخصوصية',
    account: 'الحساب',
  },

  appearance: {
    title: 'المظهر',
    description: 'تخصيص شكل ومظهر التطبيق',
    theme: 'السمة',
    light: 'فاتح',
    dark: 'داكن',
    language: 'اللغة',
  },

  notifications: {
    title: 'الإشعارات',
    description: 'اختر الإشعارات التي تريد تلقيها',
    emailAlerts: 'تنبيهات البريد الإلكتروني',
    emailAlertsDesc: 'تلقي التحديثات المهمة عبر البريد الإلكتروني',
    priceDrops: 'تنبيهات انخفاض الأسعار',
    priceDropsDesc: 'احصل على إشعار عند انخفاض أسعار العقارات المحفوظة',
    newListings: 'تنبيهات العقارات الجديدة',
    newListingsDesc: 'كن أول من يعرف عن العقارات الجديدة',
    savedSearches: 'تنبيهات البحث المحفوظ',
    savedSearchesDesc: 'تحديثات عند تطابق عقارات جديدة مع عمليات البحث الخاصة بك',
    marketingEmails: 'رسائل التسويق',
    marketingEmailsDesc: 'العروض الترويجية والنشرات الإخبارية',
  },

  privacy: {
    title: 'الخصوصية',
    description: 'تحكم في إعدادات الخصوصية والبيانات',
    showProfile: 'الملف الشخصي العام',
    showProfileDesc: 'السماح للآخرين بمشاهدة ملفك الشخصي',
    showFavorites: 'إظهار المفضلة',
    showFavoritesDesc: 'السماح للآخرين بمشاهدة عقاراتك المفضلة',
    allowAnalytics: 'تحليلات الاستخدام',
    allowAnalyticsDesc: 'ساعدنا في التحسين من خلال مشاركة بيانات الاستخدام',
    dataManagement: 'إدارة البيانات',
    downloadData: 'تحميل بياناتي',
    deleteData: 'حذف جميع البيانات',
    exportError: 'تعذّر تصدير بياناتك. يُرجى المحاولة مرة أخرى.',
  },

  account: {
    title: 'الحساب',
    description: 'إدارة حسابك وإعدادات الأمان',
    noName: 'لم يتم تعيين الاسم',
    memberSince: 'عضو منذ {{date}}',
    editProfile: 'تعديل الملف الشخصي',
    editProfileDesc: 'تحديث معلوماتك الشخصية',
    changePassword: 'تغيير كلمة المرور',
    passwordChangeComingSoon: 'ميزة تغيير كلمة المرور قادمة قريباً.',
    changePasswordDesc: 'تحديث كلمة مرور حسابك',
    twoFactor: 'المصادقة الثنائية',
    twoFactorDesc: 'إضافة طبقة أمان إضافية',
    comingSoon: 'قريباً',
    dangerZone: 'منطقة الخطر',
    signOut: 'تسجيل الخروج',
    deleteAccount: 'حذف الحساب',
    deleteConfirm: 'هل تريد حذف حسابك؟ ستتم إزالة هوية بياناتك الشخصية خلال 30 يوماً، مع الاحتفاظ بالسجلات التي يفرضها النظام (الفواتير والمعاملات). لا يمكن التراجع عن هذا الإجراء.',
    deleteSuccess: 'تم حذف حسابك.',
    deleteError: 'تعذّر حذف الحساب. يُرجى المحاولة مرة أخرى أو التواصل مع الدعم.',
    notSignedIn: 'غير مسجل الدخول',
    signInToManage: 'سجّل الدخول لإدارة إعدادات حسابك',
  },
};

export default settings;
